import React from "react";
import { t } from "i18next";
import { useDispatch } from "react-redux";

import CustomButton from "@components/shared/FormElements/CustomButton/CustomButton";
import Modals from "@components/shared/Modal/Modal";
import PageTitle from "@components/shared/PageTitle/PageTitle";
import authSlice from "@slices/auth.slice";
import modalSlice from "@slices/modal.slice";

import Member from "../Member/Member";

const MemberListing: React.FC = () => {
  const dispatch = useDispatch();
  const updateMemberListingModal = () => {
    dispatch(authSlice.actions.firstlogin(false));
    dispatch(modalSlice.actions.updateMemberListing(false));
  };
  return (
    <Modals
      flag={false}
      onClose={updateMemberListingModal}
      isModalHeader={true}
    >
      <div
        className="container fg-unit-member-listing-modal"
        data-testid="memberListing"
      >
        <div className="row">
          <div className="col-sm-12">
            <PageTitle title={t("member")}></PageTitle>
            <div className="row">
              <Member />
            </div>
            <CustomButton
              onClick={() => updateMemberListingModal()}
              buttonText={t("goToOrganisationFinder")}
            />
          </div>
        </div>
      </div>
    </Modals>
  );
};

export default MemberListing;
